module.exports = __webpack_public_path__ + "static/media/plavidvoraccetinje.c790cbb9.jpg";